import { BzgModalRef } from 'bz-genome-angular';
import { Component } from '@angular/core';


@Component({
    selector: 'fileExtensionAlert',
    template: `
      <bzg-modal-header>
  <span class="bzg-modal__header__title bz-color--neutral-500">
      <svg class="bz-icon-svg bz-icon-svg--16 bz-icon-color--error">
                  <use href="#icon-error"></use>
                </svg>
    {{ 'AUTHENTICATION.INVALID_FILE_EXTENSION' | translate }}</span>
      </bzg-modal-header>
      <bzg-modal-content class="bmc-delete-alert__body">
        <p>
          {{ 'AUTHENTICATION.INVALID_FILE_EXTENSION_MESSAGE' | translate }}
        </p>
      </bzg-modal-content>
      <bzg-modal-footer>
        <bzg-button-primary (click)="close()" color="error">{{ 'GLOBAL.CLOSE' | translate }}</bzg-button-primary>
      </bzg-modal-footer>
    `,
  styles: ['.bzg-modal__header__title {display: flex; justify-content: center; align-items: center} .bz-icon-svg {margin-right: 8px} .bz-modal__footer { display: flex; justify-content: flex-end;} .bmc-delete-alert__body {text-align: center} p {margin: 0}']
})
export class FileExtensionAlertComponent {
    constructor(public modalComponentRef: BzgModalRef) { }

    close() {
        this.modalComponentRef.close();
    }
}
